import { RefObject, useEffect } from "react";

const useClickOutside = (
  ref: RefObject<any>,
  callback: (e?: any) => void,
  dependencies?: any[]
) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback(e);
    }
  };

  useEffect(() => {
    if (ref.current) {
      document.addEventListener("click", handleClick);
    }
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ref?.current, callback, ...(dependencies ? dependencies : [])]);
};

export default useClickOutside;
